import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PortfolioImportHoldingsGridLayoutService } from '@irb/irb-create-portfolio/portfolio-import-holdings-dialog/portfolio-import-holdings.grid-layout.service';
import { IAccount } from '@irb/irb-clients/irb-clients.model';
import { ISecurity, ISecurityCustomCategories } from '@irb/irb-models/irb-models.model';
import { IPortfolioCreateRequest } from '@irb/irb-create-portfolio/irb-create-portfolio.model';
import { AppService } from '@irb/app.service';
import { IrbCreatePortfolioService, IPortfolioExistsActiveResponse } from '@irb/irb-create-portfolio/irb-create-portfolio.service';
import { IrbModelsService } from '@irb/irb-models/irb-models.service';
import { UtilityService } from '@irb-common/services/utility.service';
import { IrbCreatePortfolioEvents, IrbAppEvents } from '@irb-common/events';
import { IPortfolioDetail } from '@irb/irb-editors/irb-editors.model';
import {ProcessCellForExportParams} from "ag-grid-community";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
  selector: 'irb-portfolio-import-holdings-dialog',
  templateUrl: './portfolio-import-holdings-dialog.component.html',
  styleUrls: ['./portfolio-import-holdings-dialog.component.scss', '../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PortfolioImportHoldingsDialogComponent implements OnInit, OnDestroy {
  grid: any;
  portfolioSelectedAccountsGrid: any;
  _gridOptions: any;
  _portfolioAccountsGridOptions: any;
  unAssignedAccounts: Array<IAccount>;
  footerContent: string;
  portfolioName: string;
  _portfolioAccounts: Array<IAccount>;
  _portfolioId: number;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  totalCount: number;
  gridRowCount: number;
  uniqueField: string = 'securitySymbol';
  totalRecordsFromServer: number;
  totalSelectCount: number = 0;
  isSelectedAll: boolean = false;
  headerCheckBoxState: string = "unchecked";
  data: Array<ISecurity>;
  securitiesCustomCategories: Array<any>;
  isAltWorkflow: boolean;
  finishButtonLabel: string;
  finishButtonCallback: Function;
  postCreateCallback: Function;
  deselectedFromSelectAllRecords: Array<any> = [];
  disableActionBtn: boolean = false;
  defaultGridHeights: {
    height: string,
    domLayout:string
  };
  isUiTest = false;
  updateStatusCount=0;
  timeout=0;
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<PortfolioImportHoldingsDialogComponent>,
    private gls: PortfolioImportHoldingsGridLayoutService,
    private cdr: ChangeDetectorRef,
    public as: AppService,
    private cps: IrbCreatePortfolioService,
    //private dbs: IrbDashboardService,
    private ms: IrbModelsService,
    private util: UtilityService,
    private ats: AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public mdd: any) {
    this.securitiesCustomCategories = [];
    this.portfolioAccountsGridOptions = {
      columnDefs: this.gls.getColumnDefs(this),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No selected accounts.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
    this.computeGridHeights(0);
    this.portfolioName = this.mdd.portfolioName;
    this.portfolioId = this.mdd.portfolioId || null;
    this.portfolioAccounts = this.mdd.portfolioAccounts as Array<IAccount>;
    this.isAltWorkflow = this.mdd.isAltWorkflow || false;
    this.finishButtonLabel = this.mdd.finishButtonLabel || "Finish creating portfolio";
    this.finishButtonCallback = this.mdd.finishButtonCallback || this.createPortfolio;
    this.postCreateCallback = this.mdd.postCreateCallback || null;

    this.ms.getSecuritiesCustomCategories().subscribe((data: ISecurityCustomCategories) => {
      for (const item of data.items) {
        if (item.custCatDesc) {
          this.securitiesCustomCategories.push({ value: String(item.custCatId), name: item.custCatName });
        }
      }

      this.securitiesCustomCategories = this.util.sortByKey(this.securitiesCustomCategories, "name", 'asc');
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  close() {
    this.dialogRef.close();
  }

  onPortfolioAccountsGridReady(params: any) {
    this.portfolioSelectedAccountsGrid = params;
 }

  assignPortfolioIdIfInEditPF(cbFunc: Function) {
    if (this.portfolioId != null && this.portfolioAccounts != null && this.portfolioAccounts.length > 0) {
      this.portfolioAccounts.forEach((item: any) => {
        if (item.portfolioId == null) {
          item.portfolioId = this.portfolioId;
        }
      });

      this.cps.addAccToPortEditPage(this.portfolioAccounts).pipe(takeUntil(this.destroyed$)).subscribe((data: Array<IAccount>) => {
        this.portfolioAccounts = data;
        cbFunc();
      });
    } else {
      cbFunc();
    }
  }

  createPortfolio() {
    this.cps.addNewSecurityProfiles(this.portfolioAccounts).pipe(takeUntil(this.destroyed$)).subscribe(() => {});

    this.cps.checkIfPortfolioExists(this.portfolioName).pipe(takeUntil(this.destroyed$)).subscribe((data: Object) => {
      const r: any = data;
      if (r.responseStatus && r.responseStatus === 'EXCEPTION') {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Server Error',
            detail: "An internal server error occurred",
            sticky:true
        });
        return;
      }
      const d: IPortfolioExistsActiveResponse = data as IPortfolioExistsActiveResponse;
      const pcr: IPortfolioCreateRequest = {
        accounts: JSON.stringify(this.portfolioAccounts),
        pfExists: d.pfExists,
        portfolioName: this.portfolioName,
        securities: JSON.stringify([]),
        isActive: (d.isActive) ? null:d.isActive ,
        allowResurrection: d.allowResurrection,
        pfId: (d.pfId) ? d.pfId.toString() : null
      };

      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

      this.cps.createNewPf(pcr).pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
        const statusId=data?.responseUtilityMap.statusId;
        if (statusId) {
          this.timeout = 0;

          this.updateStatusCount=0;
          this.createNewPfCheckIntervalStart(statusId);
        } else {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.actionStatusCheckFailed();
        }
      }, error => {
        this.close();
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        console.error(error);
      });

    }, error => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      console.error(error);
    });
  }
  createNewPfCheckIntervalStart(statusId: any) {
    this.cps.createNewPfAsyncStatus(statusId).pipe(takeUntil(this.destroyed$)).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const response = statusResponse.responseData;
        const reqStatus = response.reqStatus.trim().toUpperCase();
        if (reqStatus === 'FAILED') {
          if (response.failMsg && response.failMsg.toUpperCase() === 'STALEDATAEXCEPTION') {
            this.showStaleDataDialog();
          }
          else {
            this.actionStatusCheckFailed();
          }
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.timeout=(this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
          if (this.isUiTest)
            this.timeout = 0;
          setTimeout(() => this.createNewPfCheckIntervalStart(statusId),this.timeout);
          this.updateStatusCount++;
        }
        if (reqStatus === 'COMPLETED') {
          let passingObject = {};
          if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.portfolioId) {
            passingObject = {portfolioId: statusResponse.responseUtilityMap.portfolioId}
          }
          this.actionStatusComplete(passingObject);
          this.updateStatusCount=0;
        }
      } else {
        this.close();
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }
  callFinishButtonCallback() {
    this.ats.trackClickEvent("lc_newport_finish");
    this.assignPortfolioIdIfInEditPF(() => {
      if (this.mdd.finishButtonCallback) {
        this.cps.addNewSecurityProfiles(this.portfolioAccounts).pipe(takeUntil(this.destroyed$)).subscribe(() => {
          this.finishButtonCallback(this.portfolioId, this.portfolioAccounts, this.portfolioName);
          this.close();
        });
      } else {
        this.createPortfolio();
      }
    });
  }
  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }
  actionStatusComplete(data: any) {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

    if(this.postCreateCallback) {
      this.postCreateCallback(data.portfolioId, this.portfolioAccounts, this.portfolioName);
    } else {
      this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_PORTFOLIO_CREATED, {
        portfolioName: this.portfolioName,
        portfolioDetail: data
      });
      this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    }
  }
  showStaleDataDialog() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: 'Refresh Required',
      dProceedBtnLabel: 'Refresh',
      msg: "You are attempting to create a portfolio which were modified by another user. Please refresh page to see latest changes.",
      onProceed: () => {
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      }
    });
  }
  get portfolioAccountsGridOptions() {
    return this._portfolioAccountsGridOptions;
  }

  set portfolioAccountsGridOptions(newGridOptions: any) {
    this._portfolioAccountsGridOptions = newGridOptions;
  }

  get portfolioAccounts() {
    return this._portfolioAccounts;
  }

  set portfolioAccounts(pfAccounts: Array<IAccount>) {
    this._portfolioAccounts = pfAccounts;
  }

  get portfolioId() {
    return this._portfolioId;
  }

  set portfolioId(pfId: number) {
    this._portfolioId = pfId;
  }

  computeGridHeights(totalRecords: number) {
    let defaultHeights: any;
    if(totalRecords <= 10 ) {
        defaultHeights ={
            height: null,
            domLayout:'autoHeight'
        };
    } else {
        defaultHeights ={
            height: '373px',
            domLayout:'normal'
        };
    }
    this.defaultGridHeights = defaultHeights;
    if(this.grid && this.grid.api ) {
        this.grid.api.setGridOption('domLayout', this.defaultGridHeights.domLayout);
    }

  }
}
